var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wang-editor-wrap" },
    [
      _c("Toolbar", {
        staticClass: "wang-editor-toolbar",
        attrs: {
          editor: _vm.editor,
          defaultConfig: _vm.toolbarConfig,
          mode: _vm.mode,
        },
      }),
      _c("Editor", {
        staticClass: "wang-editor-body",
        attrs: { defaultConfig: _vm.editorConfig, mode: _vm.mode },
        on: { onCreated: _vm.onCreated },
        model: {
          value: _vm.html,
          callback: function ($$v) {
            _vm.html = $$v
          },
          expression: "html",
        },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.uploading,
              expression: "uploading",
            },
          ],
          ref: "uploadMask",
          staticClass: "w-e-upload-mask",
        },
        [
          _c("div", { staticClass: "w-e-upload-panel" }, [
            _c("i", { staticClass: "el-icon-loading" }),
            _vm.uploadTotal <= 1
              ? _c("p", [_vm._v("正在上传 " + _vm._s(_vm.uploadPercent) + "%")])
              : _c("p", [
                  _vm._v(
                    "上传成功 " +
                      _vm._s(_vm.uploadSuccess) +
                      "/" +
                      _vm._s(_vm.uploadTotal)
                  ),
                ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }